"use client";
import Link from "next/link";
import { ChevronLeft, Clock4, Ribbon } from "lucide-react";
import SwiperComponent from "@/components/ui/swiper-component";
import BlogCard from "@/components/BlogCard";
import Title from "../Title";

export default function SliderBlogHorizontal({ collection_data, fields, storage_prefix_url, limit = 10, isHomeBlog }) {
    // بلاگ‌ها همراه ویجت از کوئری صفحه (getPrefixUrlDetails) می‌آیند؛ fetch کلاینتی نداریم
    const blogs = collection_data?.blogs || [];

    const displayedBlogs = blogs?.slice(0, limit) || [];

    const mobile_gutter = "px-4 md:px-10 lg:px-0";
    const mobile_swiper_gutter = "px-4! md:px-10! lg:px-0!";

    return (
        <section className="w-full mb-10">

            {/* Header */}
            <div className={`flex items-center justify-between pb-4 ${mobile_gutter}`}>
                <div className="flex items-center gap-2">
                    {fields?.icon === "ribbon" && <Ribbon size={26} />}
                    <Title
                        type={fields?.title?.type}
                        className={`flex items-center text-jmt-main font-bold text-base md:text-lg border-b-2 border-jmt-primary-800`}
                    >
                        {fields?.title?.title || ""}
                    </Title>
                </div>

                {fields?.link?.url &&
                    <Link
                        href={fields?.link?.url || "#"}
                        className="flex items-center text-xs lg:text-sm font-bold text-jmt-neutral-800 hover:text-black transition lg:gap-1">
                        {fields?.["text-link"]}
                        <ChevronLeft size={18} />
                    </Link>}
            </div>

            {/* Blog Slider */}
            <div>
                <SwiperComponent
                    slides={displayedBlogs.map((blog) => (
                        <BlogCard
                            key={blog.id}
                            blog={blog}
                            variant="horizontal"
                            storage_prefix_url={storage_prefix_url}
                        />
                    ))}
                    breakpoints={{
                        320: { slidesPerView: 1.1, spaceBetween: 8 },
                        480: { slidesPerView: 1.25, spaceBetween: 14 },
                        640: { slidesPerView: 1.8, spaceBetween: 16 },
                        768: { slidesPerView: 2.2, spaceBetween: 16 },
                        1024: { slidesPerView: 2.5, spaceBetween: 24 },
                        1280: { slidesPerView: 3, spaceBetween: 32 },
                    }}
                    slidesPerView={1.1}
                    spaceBetween={12}
                    navigation={true}
                    navPosition="side"
                    hideNavOnMobile={!!isHomeBlog}
                    grabCursor={true}
                    swiper_className={mobile_swiper_gutter}
                />
            </div>
        </section>
    );
}
